import React, { useEffect, useState } from "react";
import {
  PiCaretDownFill,
  PiCaretUpFill,
  PiCheckCircleFill,
  PiWarningFill,
} from "react-icons/pi";
import {
  batchUploadFile,
  batchUploadFileBulk,
  bulkDebitApi,
  debittingCountApi,
  faAppReport,
  getAllWorkflowMandates,
  getBulkDebit,
  mailReportApi,
  mailworkFlowReportApi,
  smsworkFlowReportApi,
  workFlowReportApi,
} from "../services";
import moment from "moment";
import { useNavigate, useParams } from "react-router";
import ReactPaginate from "react-paginate";
import LoadingModal from "../components/modals/LoadingModal";
import { Spinner } from "react-bootstrap";
import { RiDeleteBin6Line } from "react-icons/ri";
import { ModalBulkDebit } from "../components/modals/ModalBulkDebit";
import { notify } from "../components/actions/CommonActions";
import { FaListAlt } from "react-icons/fa";
import { ModalBulkDebitModal } from "../components/modals/ModalBulkDebitNew";
import * as XLSX from "xlsx";

const BulkDebit = () => {
  const [allMandates, setAllMandates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDebitting, setIsDebitting] = useState(false); // For total pages
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [limit, setLimit] = useState(10);
  const [searchloading, setSearchLoading] = useState(false);
  const [searchResult, setSearchResult] = useState(null);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showBulk, setShowBulk] = useState(false);
  const [modalUploadExcel, setModalUploadExcel] = useState(false);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isUploaded, setIsUploaded] = useState(false);
  const [note, setNote] = useState("");
  const navigate = useNavigate();

  const WORKFLOWSTATUS = {
    BILLER_INITIATED: 1,
    BILLER_AUTHORISED: 2,
    BILLER_REJECTED: 3,
    BILLER_APPROVED: 4,
    BANK_AUTHORIZED: 6,
    BANK_REJECTED: 7,
    BANK_APPROVED: 8,
    BANK_DISAPPROVED: 9,
  };

  function getWorkflowStatusLabel(statusCode) {
    const entry = Object.entries(WORKFLOWSTATUS).find(
      ([_, value]) => value === statusCode,
    );

    if (!entry) return "Unknown Status";
    const formatted = entry[0]
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return formatted;
  }

  const numberFormat = (value, toFixed = 2) => {
    const num = Number(value);
    if (Number.isInteger(num)) {
      return num.toLocaleString();
    } else {
      return num.toFixed(toFixed).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    }
  };

  const handleAllMandates = async (page, limit, search) => {
    const params = {
      limit: limit,
      page: page,
      searchTerm: search,
    };
    setSearchLoading(true);
    const searchParams = new URLSearchParams();
    // Add parameters only if they are defined and not empty
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.append(key, value);
      }
    });

    await getBulkDebit(searchParams)
      .then((res) => {
        setSearchLoading(false);
        //   console.log("all mandates res ", res?.data);
        setSearchResult(res?.data?.data);
      })
      .catch((err) => {
        setSearchLoading(false);
        console.log("err ", err);
      });
  };

  const handleDebit = async () => {
    const mandateIds = allMandates.map((mandate) => mandate.id);
    let sentData = {
      mandateIds: mandateIds,
    };

    setIsDebitting(true);
    await bulkDebitApi(sentData)
      .then((res) => {
        setIsDebitting(false);
        //   console.log("all mandates to debit res ", res?.data);
        notify(
          "success",
          "Mandate debit uploaded successfully.",
          `${res?.message}`,
        );
        setShowBulk(false);
      })
      .catch((err) => {
        setIsDebitting(false);
        console.log("err ", err);
      });
  };

  // useEffect(() => {
  //     const initiate = async () => {
  //         setLoading(true)
  //         await handleAllMandates(currentPage, limit)
  //         setLoading(false)
  //     }
  //     initiate()
  // }, [])

  const handleDelete = (id) => {
    setAllMandates((prev) => prev.filter((mandate) => mandate.id !== id));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    // console.log("e. target ",e.target.files[0]);
    setUploadedFile(file);
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Define the expected headers
        const expectedHeaders = ["contractId"];

        // Get the headers from the first row of the Excel file
        const headersInFile = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
        })[0];

        // Check if the headers in the file match the expected headers
        const isValidFile = expectedHeaders.every((header) =>
          headersInFile.includes(header),
        );

        if (!isValidFile) {
          notify(
            "danger",
            "Invalid file",
            "Invalid file structure. Please upload a file with the correct headers.",
          );
          return;
        }

        // const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // Assuming the first row contains headers/names for the properties
        const headers = headersInFile;

        // Create an array of objects using headers as property names
        // const dataArray = excelData.slice(1).map((row) => {
        //   const obj = {};
        //   headers.forEach((header, index) => {
        //     obj[header] = row[index];
        //   });
        //   return obj;
        // });

        const dataArray = XLSX.utils
          .sheet_to_json(worksheet, { header: 1 })
          .slice(1)
          .map((row) => {
            const obj = {};
            row.forEach((cell, index) => {
              if (headers[index] && worksheet[`${headers[index]}_t`] === "n") {
                const dateCode = cell;
                const jsDate = XLSX.SSF.parse_date_code(dateCode);
                obj[headers[index]] = jsDate;
              } else {
                obj[headers[index]] = cell;
              }
            });
            return obj;
          });

        setAllMandates(dataArray);
        dataArray?.length > 0 ? setIsUploaded(true) : setIsUploaded(false);
      };

      reader.readAsBinaryString(file);
    }
  };

  const handleUploadFile = async () => {
    setModalUploadExcel(false);
    const file = uploadedFile;

    const originalDate = moment(
      `${date} ${time}`,
      "YYYY-MM-DD HH:mm",
    ).toISOString();
    //   console.log("file ", file, note, originalDate);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("description", note);
    formData.append("runAt", originalDate);
    setIsLoading(true);
    await batchUploadFileBulk(formData)
      .then((res) => {
        setIsLoading(false);
        //   console.log("all mandates to debit res ", res?.data);
        notify(
          "success",
          "Mandate debit uploaded successfully.",
          `${res?.message}`,
        );
        navigate("/all-new-mandates");
      })
      .catch((err) => {
        setIsLoading(false);
        notify("danger", "OOPS", `${err?.response?.data?.message}`);
        console.log("err ", err);
      });
  };

  return (
    <>
      {loading ? (
        <div className="typewriter-container">
          <div class="typewriter">
            <div class="slide">
              <i></i>
            </div>
            <div class="paper"></div>
            <div class="keyboard"></div>
          </div>
          <code style={{ color: "#000" }}>Getting your app ready...</code>
        </div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <form
            // onSubmit={async(e)=> {
            //     e.preventDefault()
            //     setIsLoading(true);
            //     await handleAllMandates(1, 10)
            //     setIsLoading(false);
            // }}
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "10px 0",
              gap: "10px",
              position: "relative",
            }}
          >
            {!uploadedFile && (
              <input
                type="text"
                value={search}
                placeholder="Search by policy number, name, mandate code."
                onChange={async (e) => {
                  setSearch(e.target.value);
                  await handleAllMandates(1, 6, e.target.value);
                }}
                style={{
                  border: "1px solid black",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  outline: "none",
                  width: "370px",
                }}
              />
            )}
            <div>
              {!uploadedFile && allMandates?.length > 0 && (
                <button
                  type="button"
                  onClick={() => setShowBulk(true)}
                  style={{
                    border: "none",
                    backgroundColor: "#007dcc",
                    color: "white",
                    padding: "10px 10px",
                    borderRadius: "5px",
                    marginRight: "10px",
                  }}
                >
                  Bulk debit
                </button>
              )}
              {!uploadedFile && allMandates?.length < 1 && (
                <button
                  type="button"
                  onClick={() => setModalUploadExcel(true)}
                  style={{
                    border: "none",
                    backgroundColor: "#007dcc",
                    color: "white",
                    padding: "10px 10px",
                    borderRadius: "5px",
                    marginleft: "10px",
                    marginRight: "10px",
                  }}
                >
                  Upload Excel
                </button>
              )}
              <button
                type="button"
                onClick={() => navigate("/all-bulk-debit-status")}
                style={{
                  border: "none",
                  backgroundColor: "#007dcc",
                  color: "white",
                  padding: "10px 10px",
                  borderRadius: "5px",
                  marginleft: "10px",
                  marginleft: "10px",
                }}
              >
                View Uploaded Bulk Debit Status
              </button>
              {uploadedFile && allMandates?.length > 0 && (
                <button
                  type="button"
                  onClick={async () => await handleUploadFile()}
                  style={{
                    border: "none",
                    backgroundColor: "#007dcc",
                    color: "white",
                    padding: "10px 10px",
                    borderRadius: "5px",
                    marginleft: "10px",
                  }}
                >
                  Proceed
                </button>
              )}
            </div>
            {search && (
              <div
                style={{
                  width: "100%",
                  position: "absolute",
                  top: "50px",
                  left: "0px",
                  padding: "10px",
                  borderRadius: "10px",
                  backgroundColor: "white",
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.15)",
                }}
              >
                {searchloading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "20px",
                    }}
                  >
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <div>
                    {searchResult?.length > 0 ? (
                      <div>
                        {searchResult?.map((each, index) => (
                          <p
                            key={index}
                            onClick={() => {
                              setAllMandates((prev) => [...prev, each]);
                              setSearch("");
                              setSearchResult(null);
                            }}
                            style={{ marginBottom: "0px", cursor: "pointer" }}
                          >
                            {each?.name} (Policy: {each?.contractId}) (Mandate
                            code: {each?.mandateCode})
                          </p>
                        ))}
                      </div>
                    ) : (
                      <p style={{ marginBottom: "0px" }}>No result found.</p>
                    )}
                  </div>
                )}
              </div>
            )}
          </form>
          {!uploadedFile && allMandates?.length > 0 ? (
            <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
              <table className="fl-table">
                <thead>
                  <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                    {/* Table header cells */}
                    <th width="20%">Mandate Code</th>
                    <th width="20%">Subscriber Code</th>
                    <th>Full Name</th>
                    <th>Amount</th>
                    <th>Account number</th>
                    <th>WorkFLow Status</th>
                    <th>Created At</th>
                    <th>...</th>
                  </tr>
                </thead>
                <tbody>
                  {allMandates?.map((mandate) => (
                    <tr className="tr" key={mandate.id}>
                      <td className="gray-td">{mandate?.mandateCode}</td>
                      <td className="gray-td">{mandate?.contractId}</td>
                      <td className="gray-td">{mandate?.name}</td>
                      <td className="gray-td">
                        {Number(mandate?.amount).toLocaleString()}
                      </td>
                      <td className="gray-td">{mandate?.accountNumber}</td>
                      <td className="gray-td">
                        {mandate?.workFlowStatusDescription} (
                        {mandate?.workFlowStatus})
                      </td>
                      <td className="gray-td">
                        {moment(mandate?.createdAt).format("DD MMM, YYYY")}
                      </td>
                      <td onClick={() => handleDelete(mandate.id)}>
                        <RiDeleteBin6Line color="red" size={20} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            !uploadedFile && (
              <div
                style={{
                  minHeight: "60vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <FaListAlt size={40} />
                <p>No mandate selected for debit.</p>
              </div>
            )
          )}
          {uploadedFile && allMandates?.length > 0 && (
            <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
              <table className="fl-table">
                <thead>
                  <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                    {/* Table header cells */}
                    <th width="20%">S/N</th>
                    <th width="20%">Subscriber Code</th>
                  </tr>
                </thead>
                <tbody>
                  {allMandates?.map((mandate, index) => (
                    <tr className="tr" key={index}>
                      <td className="gray-td">{index}</td>
                      <td className="gray-td">{mandate?.contractId}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <LoadingModal show={isLoading} />
          <ModalBulkDebit
            show={showBulk}
            toggle={() => setShowBulk(!showBulk)}
            allMandates={allMandates}
            isUpdating={isDebitting}
            handleUpdateResumptionDate={handleDebit}
          />
          <ModalBulkDebitModal
            show={modalUploadExcel}
            toggle={() => setModalUploadExcel(!modalUploadExcel)}
            date={date}
            time={time}
            setDate={setDate}
            setTime={setTime}
            handleFileChange={handleFileChange}
            handleUploadFile={handleUploadFile}
            note={note}
            setNote={setNote}
          />
        </div>
      )}
    </>
  );
};

export default BulkDebit;
